import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { errorRoutes } from './shared/common/error/error.routing';
import { CallbackComponent } from './modules/auth/callback/callback.component';

const routes: Routes = [
  {
    path: 'callback-handler',
    component: CallbackComponent,
    data: { debug: 'Callback route in main routing' }
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/application/user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./modules/application/company/company.module').then((m) => m.CompanyModule),
  },
  {
    path: 'clients',
    loadChildren: () =>
      import('./modules/application/clients/clients.module').then((m) => m.ClientsModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'apps',
    loadChildren: () =>
      import('./modules/modules.module').then((m) => m.ModulesModule),
  },
  ...errorRoutes,
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
